/** Klasse op `body` tijdens een meerpagina-afdruk (zie styles/_global.scss, `@media print`). */
export const PRINT_FLOW_BODY_CLASS = 'e-print-flow';

/**
 * Print de huidige pagina via de browser, waarbij de app-layout (vaste hoogtes en eigen
 * scrollvlakken) tijdens het afdrukken meegroeit met de inhoud. Zonder dit knipt de browser
 * een lange pagina (bv. een tabel) af na het zichtbare scrollvlak: alleen de eerste pagina
 * wordt geprint. Pagina's die op één blad passen (cheat sheets) hebben dit niet nodig.
 */
export function printWithFlowingLayout(): void {
  const body = document.body;
  const cleanup = (): void => {
    body.classList.remove(PRINT_FLOW_BODY_CLASS);
    window.removeEventListener('afterprint', cleanup);
  };
  body.classList.add(PRINT_FLOW_BODY_CLASS);
  window.addEventListener('afterprint', cleanup);
  window.print();
}
